<template>
  <span class="i-label-main d-flex align-center">
    <v-icon small color="blue">mdi-circle</v-icon>
    <span class="pa-1 label-text">{{ label }}</span>
  </span>
</template>

<script>
export default {
  name: 'iLabel',
  props: {
    label: {
      type: String,
      default() {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.label-text {
    font-weight: bold;
    color: black;
  }
</style>